$(document).ready(function() {
  $('.slider-promotion').slick({
    infinite: false, 
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    prevArrow: '<button class="cstm_previ"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><g opacity="0.3"><g clip-path="url(#clip0_443_7898)"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.366 16.2584C10.1316 16.024 10 15.7062 10 15.3747C10 15.0432 10.1316 14.7254 10.366 14.4909L17.4372 7.4197C17.5525 7.30031 17.6905 7.20508 17.843 7.13957C17.9955 7.07406 18.1595 7.03958 18.3255 7.03813C18.4915 7.03669 18.6561 7.06832 18.8097 7.13117C18.9633 7.19402 19.1029 7.28684 19.2202 7.4042C19.3376 7.52157 19.4304 7.66113 19.4933 7.81475C19.5561 7.96837 19.5877 8.13297 19.5863 8.29895C19.5849 8.46492 19.5504 8.62895 19.4849 8.78145C19.4194 8.93396 19.3241 9.07189 19.2047 9.1872L13.0172 15.3747L19.2047 21.5622C19.4324 21.798 19.5584 22.1137 19.5556 22.4415C19.5527 22.7692 19.4213 23.0827 19.1895 23.3145C18.9577 23.5462 18.6442 23.6777 18.3165 23.6805C17.9887 23.6834 17.673 23.5574 17.4372 23.3297L10.366 16.2584Z" fill="#176B87"/></g></g><defs><clipPath id="clip0_443_7898"><rect width="30" height="30" fill="white" transform="translate(0 0.375)"/></clipPath></defs></svg></button>',
    nextArrow: '<button class="cstm_nexts"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><g clip-path="url(#clip0_443_7893)"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.634 16.2584C19.8684 16.024 20 15.7062 20 15.3747C20 15.0432 19.8684 14.7254 19.634 14.4909L12.5628 7.4197C12.4475 7.30031 12.3095 7.20508 12.157 7.13957C12.0045 7.07406 11.8405 7.03958 11.6745 7.03813C11.5085 7.03669 11.3439 7.06832 11.1903 7.13117C11.0367 7.19402 10.8971 7.28684 10.7798 7.4042C10.6624 7.52157 10.5696 7.66113 10.5067 7.81475C10.4439 7.96837 10.4123 8.13297 10.4137 8.29895C10.4151 8.46492 10.4496 8.62895 10.5151 8.78145C10.5806 8.93396 10.6759 9.07189 10.7953 9.1872L16.9828 15.3747L10.7953 21.5622C10.5676 21.798 10.4416 22.1137 10.4444 22.4415C10.4473 22.7692 10.5787 23.0827 10.8105 23.3145C11.0423 23.5462 11.3558 23.6777 11.6835 23.6805C12.0113 23.6834 12.327 23.5574 12.5628 23.3297L19.634 16.2584Z" fill="#176B87"/></g><defs><clipPath id="clip0_443_7893"><rect width="30" height="30" fill="white" transform="matrix(-1 0 0 1 30 0.375)"/></clipPath></defs></svg></button>',   
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  function updateArrowState() {
    var currentSlide = $('.slider-promotion').slick('slickCurrentSlide');
    var totalSlides = $('.slider-promotion .slick-slide').not('.slick-cloned').length;

    if (currentSlide === 0) {
      $('.cstm_previ').removeClass('active');
    } else {
      $('.cstm_previ').addClass('active');
    }

    if (currentSlide >= totalSlides - $('.slider-promotion').slick('slickGetOption', 'slidesToShow')) {
      $('.cstm_nexts').removeClass('active');
    } else {
      $('.cstm_nexts').addClass('active');
    }
  }

  updateArrowState();
  $('.slider-promotion').on('afterChange', function() {
    updateArrowState();
  });

  $(document).on('click', '.cstm_previ', function() {
    $('.slider-promotion').slick('slickPrev');
  });

  $(document).on('click', '.cstm_nexts', function() {
    $('.slider-promotion').slick('slickNext');
  });
});


 $('body').on('click','.cstm__read_more_filter',function(){
     $(this).hide();
     $(this).parents('ul').find('li').show();
   })
// promotion slider 

 $(document).ready(function() {
  $('.new_slider_left').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    prevArrow: '<button class="cstm_previ"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><g opacity="0.3"><g clip-path="url(#clip0_443_7898)"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.366 16.2584C10.1316 16.024 10 15.7062 10 15.3747C10 15.0432 10.1316 14.7254 10.366 14.4909L17.4372 7.4197C17.5525 7.30031 17.6905 7.20508 17.843 7.13957C17.9955 7.07406 18.1595 7.03958 18.3255 7.03813C18.4915 7.03669 18.6561 7.06832 18.8097 7.13117C18.9633 7.19402 19.1029 7.28684 19.2202 7.4042C19.3376 7.52157 19.4304 7.66113 19.4933 7.81475C19.5561 7.96837 19.5877 8.13297 19.5863 8.29895C19.5849 8.46492 19.5504 8.62895 19.4849 8.78145C19.4194 8.93396 19.3241 9.07189 19.2047 9.1872L13.0172 15.3747L19.2047 21.5622C19.4324 21.798 19.5584 22.1137 19.5556 22.4415C19.5527 22.7692 19.4213 23.0827 19.1895 23.3145C18.9577 23.5462 18.6442 23.6777 18.3165 23.6805C17.9887 23.6834 17.673 23.5574 17.4372 23.3297L10.366 16.2584Z" fill="#176B87"/></g></g><defs><clipPath id="clip0_443_7898"><rect width="30" height="30" fill="white" transform="translate(0 0.375)"/></clipPath></defs></svg></button>',
    nextArrow: '<button class="cstm_nexts"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><g clip-path="url(#clip0_443_7893)"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.634 16.2584C19.8684 16.024 20 15.7062 20 15.3747C20 15.0432 19.8684 14.7254 19.634 14.4909L12.5628 7.4197C12.4475 7.30031 12.3095 7.20508 12.157 7.13957C12.0045 7.07406 11.8405 7.03958 11.6745 7.03813C11.5085 7.03669 11.3439 7.06832 11.1903 7.13117C11.0367 7.19402 10.8971 7.28684 10.7798 7.4042C10.6624 7.52157 10.5696 7.66113 10.5067 7.81475C10.4439 7.96837 10.4123 8.13297 10.4137 8.29895C10.4151 8.46492 10.4496 8.62895 10.5151 8.78145C10.5806 8.93396 10.6759 9.07189 10.7953 9.1872L16.9828 15.3747L10.7953 21.5622C10.5676 21.798 10.4416 22.1137 10.4444 22.4415C10.4473 22.7692 10.5787 23.0827 10.8105 23.3145C11.0423 23.5462 11.3558 23.6777 11.6835 23.6805C12.0113 23.6834 12.327 23.5574 12.5628 23.3297L19.634 16.2584Z" fill="#176B87"/></g><defs><clipPath id="clip0_443_7893"><rect width="30" height="30" fill="white" transform="matrix(-1 0 0 1 30 0.375)"/></clipPath></defs></svg></button>',
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  function updateArrowState() {
    var currentSlide = $('.new_slider_left').slick('slickCurrentSlide');
    var totalSlides = $('.new_slider_left .slick-slide').not('.slick-cloned').length;

    if (currentSlide === 0) {
      $('.cstm_previ').removeClass('active');
    } else {
      $('.cstm_previ').addClass('active');
    }

    if (currentSlide >= totalSlides - $('.new_slider_left').slick('slickGetOption', 'slidesToShow')) {
      $('.cstm_nexts').removeClass('active');
    } else {
      $('.cstm_nexts').addClass('active');
    }
  }

  updateArrowState();
  $('.new_slider_left').on('afterChange', function() {
    updateArrowState();
  });

  $(document).on('click', '.cstm_previ', function() {
    $('.new_slider_left').slick('slickPrev');
  });

  $(document).on('click', '.cstm_nexts', function() {
    $('.new_slider_left').slick('slickNext');
  });
});


// let dataemail=document.querySelector(".k4khq");
// console.log(dataemail,"yess")


// filter icon

$('body').on('click', ".filterAccordian", function (event) {
    if (!this.classList.contains("is-open")) {
        this.classList.add("is-open")
        this.nextElementSibling.classList.add("is-open")
    }
    else {
        this.classList.remove("is-open")
        this.nextElementSibling.classList.remove("is-open")
    }

})

// Featured collection slider

 $(document).ready(function() {
    var slider = $('.custom_slider');
    var totalItems = slider.children().length;

    if (totalItems > 6) {
      // Initialize the slick slider only if there are more than 6 items
      slider.slick({
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 2,
        dots: true,
        prevArrow: '<button class="cstm_previ"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><g opacity="0.3"><g clip-path="url(#clip0_443_7898)"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.366 16.2584C10.1316 16.024 10 15.7062 10 15.3747C10 15.0432 10.1316 14.7254 10.366 14.4909L17.4372 7.4197C17.5525 7.30031 17.6905 7.20508 17.843 7.13957C17.9955 7.07406 18.1595 7.03958 18.3255 7.03813C18.4915 7.03669 18.6561 7.06832 18.8097 7.13117C18.9633 7.19402 19.1029 7.28684 19.2202 7.4042C19.3376 7.52157 19.4304 7.66113 19.4933 7.81475C19.5561 7.96837 19.5877 8.13297 19.5863 8.29895C19.5849 8.46492 19.5504 8.62895 19.4849 8.78145C19.4194 8.93396 19.3241 9.07189 19.2047 9.1872L13.0172 15.3747L19.2047 21.5622C19.4324 21.798 19.5584 22.1137 19.5556 22.4415C19.5527 22.7692 19.4213 23.0827 19.1895 23.3145C18.9577 23.5462 18.6442 23.6777 18.3165 23.6805C17.9887 23.6834 17.673 23.5574 17.4372 23.3297L10.366 16.2584Z" fill="#176B87"/></g></g><defs><clipPath id="clip0_443_7898"><rect width="30" height="30" fill="white" transform="translate(0 0.375)"/></clipPath></defs></svg></button>',
        nextArrow: '<button class="cstm_nexts"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><g clip-path="url(#clip0_443_7893)"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.634 16.2584C19.8684 16.024 20 15.7062 20 15.3747C20 15.0432 19.8684 14.7254 19.634 14.4909L12.5628 7.4197C12.4475 7.30031 12.3095 7.20508 12.157 7.13957C12.0045 7.07406 11.8405 7.03958 11.6745 7.03813C11.5085 7.03669 11.3439 7.06832 11.1903 7.13117C11.0367 7.19402 10.8971 7.28684 10.7798 7.4042C10.6624 7.52157 10.5696 7.66113 10.5067 7.81475C10.4439 7.96837 10.4123 8.13297 10.4137 8.29895C10.4151 8.46492 10.4496 8.62895 10.5151 8.78145C10.5806 8.93396 10.6759 9.07189 10.7953 9.1872L16.9828 15.3747L10.7953 21.5622C10.5676 21.798 10.4416 22.1137 10.4444 22.4415C10.4473 22.7692 10.5787 23.0827 10.8105 23.3145C11.0423 23.5462 11.3558 23.6777 11.6835 23.6805C12.0113 23.6834 12.327 23.5574 12.5628 23.3297L19.634 16.2584Z" fill="#176B87"/></g><defs><clipPath id="clip0_443_7893"><rect width="30" height="30" fill="white" transform="matrix(-1 0 0 1 30 0.375)"/></clipPath></defs></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 426,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  });